import axios from "./axios";

export class AuthModel {
  requestPasswordReset = (email) => {
    return axios.post("api/auth/password_reset/request", { email });
  };

  passwordReset = ({ token, email, password, password_confirmation, question, answer }) => {
    return axios.post("api/auth/password_reset/process", {
      token,
      email,
      password,
      password_confirmation,
      question,
      answer,
    });
  };

  passwordUpdate = ({ password, password_confirmation, current_password }) =>
    axios.post("api/api/auth/password_update", { password, password_confirmation, current_password });

  doLogin = (email, password) => {
    return axios.post("login", { email, password });
  };

  doLogout = () => {
    return axios.post("logout");
  };

  getSession = async (config = undefined) => {
    try {
      const res = await axios.get("api/user", config);
      return res.data.data;
    } catch (error) {
      return error;
    }
  };

  uniqueEmail = (email) => {
    return axios.post("api/validate/unique_email", { email });
  };

  register = (obj) => {
    return axios.post("api/register", obj);
  };

  addRecoveryQuestion = (data, config) => axios.post("api/user_recovery", data, config);
}

const Auth = new AuthModel();

export default Auth;
